// MOCK mode: run fully offline against the in-browser sim (no server, no auth).
// Enabled when there's no API URL configured, or ?mock is present in the URL.
// This is also the e2e test harness — the sim mimics the Realtime data shapes.
// Not to be confused with SIM mode (VITE_SIM=1, the local replay stack), which is
// a live mode against localhost and never goes MOCK, not even with ?mock.
export const MOCK: boolean = (() => {
  if (import.meta.env.VITE_SIM === '1') return false;
  try {
    if (typeof location !== 'undefined' && new URLSearchParams(location.search).has('mock')) return true;
    if (typeof location !== 'undefined' && new URLSearchParams(location.search).has('live')) return false;
  } catch { /* ignore */ }
  return !import.meta.env.VITE_API_URL;
})();
